import { Divider } from '@mui/material'
import { useMap } from '@vis.gl/react-google-maps'
import { AppBox, AppTypography, GoogleMap } from 'components'
import { AppGoogleMapUniqueKeys } from 'globals/constants'
import { FC, useEffect } from 'react'
import { CrmCompanyViewModel, ParkSiteMapPin } from 'sdk'
import { useAppDispatch } from 'store/app.store'
import { setCrmCompanyAddressPin } from 'store/slices'

interface Props {
  company?: CrmCompanyViewModel
}
export const CrmCompanyDetailLocation: FC<Props> = ({ company }) => {
  const dispatch = useAppDispatch()
  const map = useMap(AppGoogleMapUniqueKeys.ParkSitesMap)
  const getPin = () => {
    if (!company) {
      return
    }
    const fullAddress = [company.Address, company.Address2, company.City, company.Zip]
      .filter((field) => field) // Remove null/empty fields
      .join(', ') // Join with a comma and space

    if (!!!fullAddress) {
      dispatch(setCrmCompanyAddressPin(null))
      return
    }

    // Encode the address for use in the URL
    const encodedAddress = encodeURIComponent(fullAddress)

    // Make a request to the Google Maps Geocoding API
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodedAddress}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`
    fetch(url)
      .then((x) => {
        x.json()
          .then((x) => {
            if (x.status === 'OK') {
              const location = x.results[0].geometry.location
              dispatch(
                setCrmCompanyAddressPin(
                  new ParkSiteMapPin({
                    I: 'company-address',
                    L: location.lat,
                    N: location.lng,
                  })
                )
              )
              map?.setCenter({ lat: location.lat, lng: location.lng })
            }
          })
          .catch(() => {
            dispatch(setCrmCompanyAddressPin(null))
          })
      })
      .catch((x) => {
        dispatch(setCrmCompanyAddressPin(null))
      })
  }

  useEffect(() => {
    dispatch(setCrmCompanyAddressPin(null))
    map?.setZoom(8)
    getPin()
  }, [company])
  return (
    <AppBox
      border={1}
      padding={2}
      paddingY={4}
      backgroundColor="white"
      borderColor={'grey.200'}
      borderRadius={6}
      id="Company"
    >
      <AppBox width={'100%'}>
        <AppTypography fontWeight={700} fontSize={'1rem'}>
          Office Location
        </AppTypography>
        <Divider sx={{ marginY: 2.5 }} />
        <AppBox width={1} height={'450px'} backgroundColor="black">
          <GoogleMap />
        </AppBox>
      </AppBox>
    </AppBox>
  )
}
